
import '../styles/BlogStyles/BlogStyles.css';
import { Link } from 'react-router-dom';
import blog from "../assets/blog.jpeg";
import bloglist from "../assets/bloglist.jpeg";


const BlogList = () => {
  return (
    <div className="blog-page-wrapper">
      
      {/* 1. Hero Section with Laptop Image */}
      <section className="blog-hero position-relative">
        <img 
          src={blog} 
          alt="Blog Header Laptop" 
          className="w-100 img-fluid blog-hero-img"
        />
      
      </section>

      {/* 2. Blog Post Grid */}
      <section className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            
            {/* Blog Card */}
            <div className="card h-100 shadow-sm border-0 blog-card">
              <div className="overflow-hidden rounded-top">
                <img 
                  src={bloglist}
                  alt="Classroom" 
                  className="card-img-top blog-card-img"
                />
              </div>
              <div className="card-body p-4">
                <h5 className="card-title fw-bold text-dark mb-3">
                  How to Choose Between Indian & Global Professional Certifications: A Student’s Guide
                </h5>
                <p className="card-text text-muted small mb-4 line-clamp-3">
                  In today's interconnected world, students in India have more certification options than ever before. 
                  On one side, there are Indian professional certifications like CA, CMA, and CS...
                </p>
                {/* Navigation Link to the Detail Page */}
                <Link to="/blog/indian-vs-global-certifications" className="btn btn-purple px-4 py-2">
                  Read More
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default BlogList;